module.exports = __webpack_public_path__ + "assets/media/day38.a36dacc2.mp3";